export default "__VITE_ASSET__Dybv9J9K__"